import React from 'react';
import b_ from 'b_';

import {VHVideoState} from 'client/common/types';
import {SurveyState} from 'client/common/store/reducers/survey/types';

import I18N from 'assets/i18n/brandlift-project';

import './creative-settings-form.css';
import { Icon } from 'client/common/components/lego';

const i18n = I18N.creatives.creativeSettings;
const b = b_.with('creative-settings-form');

interface StateBadgeProps {
    title?: string;
    label?: string;
    type?: 'info' | 'success' | 'error';
    surveyState: SurveyState;
    creativeState: VHVideoState;
    isPayed: boolean;
}

// eslint-disable-next-line complexity
export default function StateBadge(props: StateBadgeProps) {
    let {title = '', label = '', type = 'info'} = props;
    const {surveyState, creativeState, isPayed} = props;

    switch (creativeState) {
        case 'new':
        case 'transcoding':
        case 'moderating':
            title = i18n.badge.videoUploading;
            if (surveyState === 'DRAFT') {
                label = i18n.badge.draft;
            }

            if (surveyState === 'MODERATION') {
                label = isPayed ? i18n.badge.moderation : i18n.badge.moderationWithPay;
                type = 'success';
            }
            break;
        case 'error':
            title = i18n.badge.uploadErrorTitle;
            label = i18n.badge.uploadErrorLabel;
            type = 'error';
            break;
        case 'banned':
        case 'moderator_banned':
            title = i18n.badge.videoBannedTitle;
            label = i18n.badge.videoBannedLabel;
            type = 'error';
            break;
        case 'ready':
            type = 'success';

            if (surveyState === 'MODERATION') {
                label = isPayed ? i18n.badge.moderation : i18n.badge.moderationWithPay;
            }

            if (surveyState === 'ACTIVE') {
                label = i18n.badge.active;
            }
            break;
        default:
            break;
    }

    if (!title && !label) {
        return null;
    }

    const iconType = type === 'error' ? 'error' : 'help';

    return (
        <div className={b('video-upload-progress-info', {type})}>
            <Icon
                type={iconType}
                className={b('video-upload-icon', {type: iconType})}
            />
            <div className={b('video-upload-progress-info-content')}>
                {title && <div className={b('video-upload-progress-info-title')}>{title}</div>}
                {label && <div className={b('video-upload-progress-info-desc')}>{label}</div>}
            </div>
        </div>
    );
}
